import React, { Fragment, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { OnboardingLayout } from 'layouts/OnboardingLayout';
import { useMetrics } from 'hooks/metrics/useMetrics';
import './style.scss';
import { getRegion } from 'utils/Region';
import AlertModal from 'components/AlertModal';
import { QRLinkingErrorModal } from 'components/QRLinkingErrorModal';

export const QRLinkingErrorTriesExceeded = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();

  const [showErrorAlert, setShowErrorAlert] = useState(true);

  const onClose = () => {
    setShowErrorAlert(false);
    navigate(`/${getRegion()}/landing`, { replace: true });
  };
  return (
    <Fragment>
      <div className="QRLinkingErrorTriesExceeded">
        <QRLinkingErrorModal
          show={showErrorAlert}
          setShow={setShowErrorAlert}
          handleExit={onClose}
        />
      </div>
    </Fragment>
  );
};
